import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { Draggable } from "gsap/Draggable";
import { InertiaPlugin } from "gsap/InertiaPlugin";

gsap.registerPlugin(ScrollTrigger, SplitText, Draggable, InertiaPlugin);

export default defineNuxtPlugin((nuxtApp) => {
  window.gsap = gsap;
  window.ScrollTrigger = ScrollTrigger;
  window.SplitText = SplitText;
  window.Draggable = Draggable;
  window.InertiaPlugin = InertiaPlugin;

  return {
    provide: {
      gsap,
      ScrollTrigger,
      SplitText,
      Draggable,
      InertiaPlugin,
    },
  };
});
